import React, {
  useReducer,
  useRef,
  useEffect,
  useLayoutEffect,
} from 'react';
import styles from './systemEventTimelineStyles.scss';

const MatchedFilterInfoButton = ({ filter }) => {
  const [popupState, popupDispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'TOGGLE':
          return { isOpen: !state.isOpen };
        case 'CLOSE':
          return { isOpen: false };
        default:
          return state;
      }
    },
    { isOpen: false },
    undefined,
  );

  const buttonRef = useRef(null);
  const popupRef = useRef(null);
  const containerRef = useRef(null);

  const togglePopup = (e) => {
    e.stopPropagation();
    popupDispatch({ type: 'TOGGLE' });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)
        && buttonRef.current && !buttonRef.current.contains(event.target)) {
        popupDispatch({ type: 'CLOSE' });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useLayoutEffect(() => {
    if (popupState.isOpen && popupRef.current && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const popupRect = popupRef.current.getBoundingClientRect();

      let top = buttonRect.bottom + 5;
      let left = buttonRect.left + buttonRect.width / 2 - popupRect.width / 2;

      if (left + popupRect.width > window.innerWidth) {
        left = window.innerWidth - popupRect.width - 10;
      }

      if (left < 10) {
        left = 10;
      }

      if (top + popupRect.height > window.innerHeight) {
        top = buttonRect.top - popupRect.height - 5;
      }

      popupRef.current.style.position = 'fixed';
      popupRef.current.style.left = `${left}px`;
      popupRef.current.style.top = `${top}px`;
    }
  }, [popupState.isOpen]);

  const matchCriteria = [
    { id: 'CarrierMatched', label: 'Carrier Matched' },
    { id: 'ShipmentTypeMatched', label: 'Shipment Type Matched' },
    { id: 'ShipmentStateMatched', label: 'Shipment State Matched' },
    { id: 'CalculatedEventMatched', label: 'Calculated Event Matched' },
    { id: 'CustomEventTypeMatched', label: 'Custom Event Type Matched' },
    { id: 'TagsMatched', label: 'Shipment Tags Matched' },
  ];

  const getAllMatchedCriteria = () => {
    if (!filter.matched_on || filter.matched_on.length === 0) {
      return matchCriteria.map(criteria => ({
        ...criteria,
        matched: false,
      }));
    }

    const matchedMap = new Map();
    filter.matched_on.forEach(reason => {
      const label = typeof reason === 'string' ? reason
        : (reason.name || reason.label || reason.key || reason.check || '');

      matchCriteria.forEach(criteria => {
        if (label.includes(criteria.id)) {
          matchedMap.set(criteria.id, true);
        }
      });
    });

    return matchCriteria.map(criteria => ({
      ...criteria,
      matched: matchedMap.has(criteria.id)
        || (filter.matched_on.some(r => typeof r === 'string' && r.includes(criteria.id))),
    }));
  };

  const allCriteria = getAllMatchedCriteria();

  return (
    <div
      ref={containerRef}
      className={styles.filterInfoButtonContainer}
    >
      <button
        ref={buttonRef}
        type="button"
        className={styles.filterInfoButton}
        onClick={togglePopup}
        aria-expanded={popupState.isOpen}
        aria-label={`View match results for ${filter.name}`}
      >
        i
      </button>
      {popupState.isOpen && (
        <div
          ref={popupRef}
          className={styles.filterInfoPopup}
        >
          <div className={styles.filterInfoPopupTitle}>
            <div className={styles.filterInfoPopupHeading}>Shipment Event Filter Information</div>
            <div className={styles.filterInfoPopupMeta}>
              <span className={styles.filterInfoPopupMetaLabel}>Name</span>
              <span>{filter.name}</span>
            </div>
            <div className={styles.filterInfoPopupMeta}>
              <span className={styles.filterInfoPopupMetaLabel}>ID</span>
              <span>{filter.id}</span>
            </div>
          </div>
          <div className={styles.matchResultsTitle}>Match Results</div>

          <ul className={styles.filterCheckList}>
            {allCriteria.map((criteria) => {
              const isMatched = criteria.matched;

              return (
                <li key={criteria.id} className={styles.filterCheckRow}>
                  <span className={`${styles.filterCheckIcon} ${isMatched ? styles.filterCheckPass : styles.filterCheckFail}`}>
                    {isMatched ? '✓' : '✗'}
                  </span>
                  <span className={styles.filterCheckLabel}>
                    {criteria.label}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MatchedFilterInfoButton;
